module.exports = __webpack_public_path__ + "img/no-image.f6bda981.png";